import "es6-promise/auto";
import axios from "axios";
import { config } from "../constants/config";

const apiUrl = config.API_URL;

const ID_TOKEN_KEY = "user_id";
const USER_NAME = "username";
const ACCESS_TOKEN_KEY = "access_token";
const EXPIRATION_DATE = "expiration_date";
const JWT_TOKEN_KEY = "jwt_token";

export function login(user, password) {
  var params = new URLSearchParams();
  params.append("domainName", "core");
  params.append("userName", user);
  params.append("password", password);

  return axios({
    method: "post",
    url: apiUrl + "/Login",
    data: params
  })
    .then(res => {
      if (res.data.ID) {
        SetAuthData(res);
      }
      return res.data;
    })
    .catch(error => {
      return error.response.data;
    });
}

export function loginEntra(user, token) {
  var params = new URLSearchParams();
  params.append("domainName", "core");
  params.append("userName", user);
  params.append("accessToken", token);

  return axios({
    method: "post",
    url: apiUrl + "/Login",
    data: params
  })
    .then(res => {
      if (res.data.ID) {
        SetAuthData(res);
      }
      return res.data;
    })
    .catch(error => {
      return error.response.data;
    });
}

function SetAuthData(res) {
  setAccessToken(res.data.AuthToken);
  setIdToken(res.data.ID);
  setUser(res.data.FirstName + " " + res.data.Name);
  setJwtToken(res.data.JwtToken);

  // Set the expiration date to 3 am the next day
  const nextDay = new Date();
  nextDay.setDate(nextDay.getDate() + 1);
  nextDay.setHours(3, 0, 0, 0);
  setExpirationDate(nextDay.getTime());
}

export function logout() {
  localStorage.clear();
  window.location.replace("/signin");
}

export function getIdToken() {
  return localStorage.getItem(ID_TOKEN_KEY);
}

export function getJwtToken() {
  return localStorage.getItem(JWT_TOKEN_KEY);
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getUser() {
  return localStorage.getItem(USER_NAME);
}

function setIdToken(token) {
  localStorage.setItem(ID_TOKEN_KEY, token);
}

function setJwtToken(token) {
  localStorage.setItem(JWT_TOKEN_KEY, token);
}

function setAccessToken(token) {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
}

function setUser(token) {
  localStorage.setItem(USER_NAME, token);
}

function setExpirationDate(date) {
  localStorage.setItem(EXPIRATION_DATE, date);
}

export function isLoggedIn() {
  const idToken = getIdToken();
  return !!idToken && !isTokenExpired();
}

function getTokenExpirationDate() {
  return localStorage.getItem(EXPIRATION_DATE);
}

function isTokenExpired() {
  const expirationDate = getTokenExpirationDate();
  const dateNow = new Date();
  return expirationDate < dateNow.getTime();
}
